export const ApplicationConstant = {
    ApplicationID : 6,
    clientId : 5,
    organizationId: 5,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
}